<template>
<section class="section research" id="research">
    <div class="page-wrap"><div class="title-row"><h2>بحوث ومعارف في السنة</h2><RouterLink to="/research/shamela-hadith-sciences">استكشف البحوث <i class="bi bi-arrow-left"></i></RouterLink></div>
      <div class="research-grid reveal-stagger">
        <article><div class="research-img paper"></div><h3>ضوابط التعامل مع الأخبار في ضوء السنة</h3><small>بحوث في السنة · 19 يونيو 2024</small></article>
        <article><div class="research-img books"></div><h3>أثر السنة النبوية في بناء الحضارة</h3><small>بحوث في السنة · 28 أبريل 2024</small></article>
        <article><div class="research-img library"></div><h3>منهج المحدثين في نقد الروايات</h3><small>بحوث في السنة · 21 مايو 2024</small></article>
      </div>
    </div>
  </section>
</template>

